import { TeamCards } from "./TeamCards";
import type { TeamCardsProps } from "./TeamCards.d";

export { TeamCards, TeamCardsProps };
